module.exports = __webpack_public_path__ + "img/amige.e47f295c.svg";